module.exports = __webpack_public_path__ + "static/media/libby.5138d0b0.jpg";